<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :field-name="fieldName" />

    <!--  사업장 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> {{ workplaceLabel }} 정보</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업내용(필수)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <ml-input v-else v-model="form.inputB_1" class="w-full flex-1" :readonly="board.readonly" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">조사일(필수)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_5" :readonly="board.readonly" />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업자(필수)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <ml-input v-else v-model="form.inputB_4" class="w-full flex-1" :readonly="board.readonly" />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">재해형태(필수)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
        <disaster-class-selector v-else class="w-full flex-1" v-model="form.inputB_6" :readonly="board.readonly" :custom-disaster-list="customDisasterList" :multiple="true" />
      </div>
    </div>

    <!--    유해·위험요인 분야-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 유해·위험요인 분야</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center" v-for="(row, indexRows) in form.checkList" :key="indexRows">
        <div v-if="isPrint" class="flex items-center">
          <div v-if="row.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ row.title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="row.check">{{ row.title }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <div v-for="(row, indexRows) in form.checkList" :key="indexRows" class="mt-5">
      <table-inspect
        v-if="row.check"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        :list="row.inspectList"
        :table-header-title="row.title"
        :table-header-yes="'작성'"
        :table-header-no="'미작성'"
        :table-header-note="'비고'"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        @update-note="
          (param1, param2) => {
            updateListNote(indexRows, param1, param2);
          }
        "
      />
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 사진" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

import * as inspectData from "./inspectData";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";

import { required } from "vuelidate/lib/validators";
import {researchDisasters} from "@/util/DisasterDataResearch";

export default {
  components: {
    DisasterClassSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
  },
  validations: {
    form: {
      inputB_1: { required },
      inputB_5: { required },
      inputB_4: { required },
      inputB_6: { required },
    },
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: [],

        photoList: [],
        fileList: [],
        checkList: [
          { title: "기계적 요인", check: true, inspectList: JSON.parse(JSON.stringify(inspectData))['기계적요인'] },
          { title: "전기적 요인", check: false, inspectList: JSON.parse(JSON.stringify(inspectData))['전기적요인'] },
          { title: "화학(물질)적 요인", check: false, inspectList: JSON.parse(JSON.stringify(inspectData))['화학적요인'] },
          { title: "생물학적 요인", check: false, inspectList: JSON.parse(JSON.stringify(inspectData))['생물학적요인'] },
          { title: "작업특성 요인", check: false, inspectList: JSON.parse(JSON.stringify(inspectData))['작업특성요인'] },
          { title: "작업환경 요인", check: false, inspectList: JSON.parse(JSON.stringify(inspectData))['작업환경요인'] },
        ],
      },
      customDisasterList: researchDisasters,
    };
  },
  computed: {
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    is내부종사자 () {
      return `${this.projectId}` === '2'
    },
    workplaceLabel() {
      if (`${this.projectId}` === '3') {
        return '사업'
      } else {
        return '사업장'
      }
    },
    fieldName () {
      if (`${this.projectId}` === '3') {
        return '사업명(필수)'
      }
      return '사업장명(필수)'
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    updateListCheck(indexList, indexRows, text) {
      this.form.checkList[indexList].inspectList[indexRows].is_checked = text;
    },
    updateListNote(indexList, indexRows, text) {
      this.form.checkList[indexList].inspectList[indexRows].note = text;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.inputB_1.required) {
          alert("작업내용을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputB_5.required) {
          alert("조사일을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputB_4.required) {
          alert("작업자를 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputB_6.required) {
          alert("재해형태를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
